export const DOCS_URL = 'https://docs.monospace.io/';
export const RELEASE_NOTES_URL = 'https://docs.monospace.io/en/release-notes/changelog';
export const ROADMAP_URL = 'https://feedback.monospace.io/';
export const FEEDBACK_URL = 'https://feedback.monospace.io/?request=new';
